import styled from 'styled-components';

export const card = styled.div`
    background: var(--TA-color-bg-surface-default);
    border-radius: var(--radius-md);
    padding: var(--space-sm) var(--space-lg);
    margin: var(--space-lg);
`;
